import Vue from "vue";
import hljs from "highlight.js";

import "../styles/code.css";
import "firacode/distr/fira_code.css";
import "highlight.js/styles/androidstudio.css";

Vue.use(hljs.vuePlugin);
